import { combineReducers } from '@reduxjs/toolkit';
import { uiReducer } from './slices/uiSlice';
import { notificationReducer } from './slices/notificationSlice';
import { authReducer } from '@/features/auth/store/authSlice';
import { chatReducer } from '@/features/chat/store/chatSlice';

export const rootReducer = combineReducers({
    ui: uiReducer,
    notifications: notificationReducer,
    auth: authReducer,
    chat: chatReducer,
});
